import { initializeApp } from 'firebase/app'
import { getAuth, signOut } from 'firebase/auth'

import { firebaseConfig } from 'settings/constants/firebase'

export const app = initializeApp(firebaseConfig, 'auth')

export const auth = getAuth(app)

export const handleLogoutAuthApp = () => signOut(auth)

export const getToken = (): Promise<string | undefined> => {
  const user = auth?.currentUser
  if (user) {
    return user.getIdToken()
  }

  return Promise.resolve(undefined)
}

// Keyed by uid so an impersonation or account switch never hands the new user the outgoing one's refresh.
let pendingFreshToken: { uid: string; promise: Promise<string> } | null = null

export const getFreshToken = (): Promise<string | undefined> => {
  const user = auth?.currentUser
  if (!user) {
    return Promise.resolve(undefined)
  }

  if (pendingFreshToken?.uid !== user.uid) {
    const promise = user.getIdToken(true).finally(() => {
      if (pendingFreshToken?.promise === promise) {
        pendingFreshToken = null
      }
    })
    pendingFreshToken = { uid: user.uid, promise }
  }

  return pendingFreshToken.promise
}

// Best effort: a failed or stalled refresh leaves the cached token in place instead of holding the caller.
export const refreshTokenWithin = (timeoutMs: number): Promise<void> =>
  Promise.race([
    getFreshToken().then(() => undefined),
    new Promise<void>(resolve => {
      setTimeout(resolve, timeoutMs)
    }),
  ]).catch(() => undefined)
